import React, { memo, useState, useEffect } from 'react'
import { get, keys, map } from 'lodash'
import { toast } from 'react-toastify'

import PropTypes from 'prop-types'
import cn from 'classnames'

import Button from './Button'

import styles from './DropDown.module.scss'

const RevenueCenterTitle = ({ className, currentMenu, menus, forceMenuChange, nextMenuUuid, setCurrentMenuId, clearCart, cartItemsExist }) => {
  const classNames = cn(styles.dropDown, className)
  const [showModal, toggleModal] = useState(false)
  const [toastMessage, setToastMessage] = useState({ show: false, id: null })

  const MenuChangeNotification = ({ menuUuid }) => (
    <div className={styles.toastMessage}>
      <div><span className={styles.label}>Warning: </span> Selecting this menu will remove all current menu items from the cart. Do you wish to continue?</div>
      <div className={styles.buttons}>
        <Button className={styles.actionButton} onClick={() => setNewMenu(menuUuid)}>Yes</Button>
        <Button className={styles.actionButton} onClick={toggleMenusAndMessages}>No</Button>
      </div>
    </div>
  )

  const toggleMenusAndMessages = () => {
    toggleModal(!showModal)
    toast.dismiss(toastMessage.id)
    setToastMessage({ show: false, id: null })
  }

  const setNewMenu = (menuUuid) => {
    setCurrentMenuId(menuUuid)
    toggleMenusAndMessages()
    clearCart()
  }

  const handleMenuChange = (menuUuid) => {
    if (menuUuid !== currentMenu.uuid && cartItemsExist) {
      if (!toastMessage.show) {
        const toastId = toast(<MenuChangeNotification menuUuid={menuUuid} />, { autoClose: false, closeOnClick: false })
        setToastMessage({ show: true, id: toastId })
      }
    } else {
      setNewMenu(menuUuid)
    }
  }

  const hasMultipleMenus = keys(menus).length > 1

  const openMultiMenuSelectModal = () => {
    if (hasMultipleMenus) {
      toggleModal(!showModal)
    }
  }

  const downArrow = hasMultipleMenus ? (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
    >
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M1.414 0h13.6a1 1 0 0 1 .708 1.707l-6.8 6.8a1 1 0 0 1-1.415 0l-6.8-6.8A1 1 0 0 1 1.414 0z"
      />
    </svg>
  ) : null

  const upArrow = (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
    >
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M1.414 9.215h13.6a1 1 0 0 0 .708-1.708l-6.8-6.8a1 1 0 0 0-1.415 0l-6.8 6.8a1 1 0 0 0 .707 1.708z"
      />
    </svg>
  )

  let modalElement = null

  if (showModal) modalElement = (
    <div className={styles.menuSelectOverlay}>
      <div className={styles.menuSelectModal}>
        <div
          className={styles.modalHeader}
          onClick={toggleMenusAndMessages}
        >
          <div className={styles.currentSelectedMenu}>
            {currentMenu.name}
          </div>
          <div className={styles.arrow}>{upArrow}</div>
        </div>
        {map(menus, menu =>
          menu.uuid !== get(currentMenu, 'uuid') ? (
            <div
              key={menu.uuid}
              className={styles.menuSelect}
              onClick={() => handleMenuChange(menu.uuid)}
            >
              {menu.name}
            </div>
          ) : null
        )}
      </div>
    </div>
  )

  useEffect(() => {
    if (forceMenuChange) {
      setCurrentMenuId(nextMenuUuid)
    }
  }, [forceMenuChange, nextMenuUuid, setCurrentMenuId])

  return (
    <div className={classNames}>
      {modalElement}
      <div className={styles.titleHeader} onClick={openMultiMenuSelectModal}>
        <span className={styles.name}>{get(currentMenu, 'name')}</span>
      </div>
    </div>
  )
}

RevenueCenterTitle.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
}

export default memo(RevenueCenterTitle)
